import React, { useState, useEffect } from 'react';
import '../App.css';
import { Link, useNavigate } from 'react-router-dom';
import * as Colors from './colors'
import { Form, FormGroup, Button, Label, Input } from 'reactstrap';
import user from '../assets/user.png';
import MyLoader from './util/loader'
import MyError from './util/error'
import MyStorage from './util/storage'
import Api from './api/api'

const Login = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState('');
  const [loader, setLoader] = useState(false);

  // if (MyStorage.isLogin()) {
  //   console.log('already logged in');
  //   navigate('/')
  //   return null
  // }

  const loginAdmin = () => {
    if (email === '' || password === '') {
      return
    }

    setLoader(true)
    Api.login(email, password,
      (user) => {
        setLoader(false)
        console.log('email: ' + user.email);
        console.log('password: ' + user.password);
        MyStorage.setUser(user)
        navigate('/admin/products')
      },
      (error) => {
        setLoader(false)
        setShowError(true)
        setError(error)
      })
  };

  return (
    <div className='app'>
      <div className='text-center text-white'>
        <h4>
          PatientChoice Admin
        </h4>
      </div>
      <Form className="form">
        <FormGroup>
          <Input
            type='email'
            placeholder='Email'
            value={email}
            onChange={(event) => setEmail(event.target.value)} />
        </FormGroup>
        <FormGroup
          style={{ marginTop: 10 }}>
          <Input
            type='password'
            placeholder='Password'
            value={password}
            onChange={(event) => setPassword(event.target.value)} />
        </FormGroup>

        <MyError showError={showError} error={error} />

        <Button
          style={{ marginTop: 20, fontSize: 16, backgroundColor: Colors.themeColor, borderWidth: 0 }}
          className='btn-block btn-dark'
          onClick={loginAdmin}>
          Login
        </Button>

      </Form>
      <MyLoader loader={loader} marginTop={-10} />
    </div>
  );
}

export default Login; 